import {
  IListActionRequest,
  IListItemAction,
  INewListRequest,
  MyListService,
} from "@wbmason/my-list-service";
import { useEffect } from "react";
import useAddToList from "../../hooks/useAddToList";
import { ListAction } from "@wbmason/my-list-service/constants/enums";

// set it to true to test my list service
const enableTestButton = false;

export interface IMyListsProviderProps {
  onAddToListAction: (
    itemsToAdd: IListItemAction[] | null,
    actionType: number
  ) => void;
  onAddToListEnabled: (enabled: boolean) => void;
  onManageListAction: (
    listRequest: INewListRequest | null,
    listAction: ListAction,
    pageName?: string
  ) => void;
}

export function MyListsProvider(props: IMyListsProviderProps) {
  const { onAddToListAction, onAddToListEnabled, onManageListAction } = props;
  const enableAddToList = useAddToList();

  useEffect(() => {
    if (enableAddToList) {
      const addItemsSub = MyListService.getItemsToAddSubject().subscribe(
        (listItemResponse) => {
          const [itemsToAdd, actionType] = listItemResponse;
          onAddToListAction(itemsToAdd, actionType);
        }
      );

      const manageListSub = MyListService.getListUpdateSubject().subscribe(
        (listResponse: IListActionRequest) => {
          const { listRequest, listAction, pageName } = listResponse;
          onManageListAction(listRequest, listAction, pageName);
        }
      );

      return () => {
        addItemsSub.unsubscribe();
        manageListSub.unsubscribe();
      };
    }
  }, [enableAddToList, onAddToListAction, onManageListAction]);

  useEffect(() => {
    onAddToListEnabled(enableAddToList);
  }, [enableAddToList, onAddToListEnabled]);

  return (
    <>
      {enableTestButton && (
        <>
          <div>
            <button
              onClick={() => {
                MyListService.emitItemsToAdd(
                  [
                    {
                      itemIdentifier: {
                        id: "DRP5516",
                        unitId: "PK",
                        couponOfferCode: "",
                      },
                      qty: 1,
                      itemPosition: 2,
                    },
                  ],
                  2
                );
              }}
            >
              Test Add To List
            </button>
          </div>
          <div>
            <button
              onClick={() =>
                MyListService.emitListToUpdate(
                  {
                    name: "<ClosTest1",
                    id: "ilCcT/X0Dg4gQFXQttQHZw==",
                    listType: { name: "Personal" },
                    sortCode: { code: "BA", description: "Brand A-Z" },
                    assignmentType: {
                      name: "Inclusion",
                      displayName: "Available",
                    },
                    displayAsList: true,
                  },
                  ListAction.Edit
                )
              }
            >
              List Settings
            </button>
          </div>
          <div>
            <button onClick={() => MyListService.emitListToUpdate()}>
              Add new list
            </button>
          </div>
          <div>
            <button
              onClick={() =>
                MyListService.emitListToUpdate(
                  {
                    name: "account level test",
                    id: "AJlZd4LXbxJQ58Oo6fCQOQ==",
                    listType: { name: "Personal" },
                    sortCode: { code: "BA", description: "Brand A-Z" },
                    assignmentType: {
                      name: "ReInclusion",
                      displayName: "Override Restrict",
                    },
                    displayAsList: true,
                  },
                  ListAction.Copy
                )
              }
            >
              Copy List
            </button>
          </div>
          <div>
            <button
              onClick={() =>
                MyListService.deleteList(
                  JSON.stringify("mZA3/uTODrrnIcjTbO92og=="),
                  "test-page"
                )
              }
            >
              Delete List
            </button>
          </div>
        </>
      )}
    </>
  );
}
